import { render, staticRenderFns } from "./personCenter.vue?vue&type=template&id=57ae693c&scoped=true&"
import script from "./personCenter.vue?vue&type=script&lang=js&"
export * from "./personCenter.vue?vue&type=script&lang=js&"
import style0 from "./personCenter.vue?vue&type=style&index=0&id=57ae693c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ae693c",
  null
  
)

export default component.exports